const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/loop/$loopId/dashboard/route.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { requirePermission } from '@/lib/hooks/common/usePermissions';
import i18n from '@/lib/translations/i18n';
import { insightsDeliverablesSearchSchema } from '@/lib/zod-schemas/insightsSearchSchema';
export const Route = createFileRoute('/(app)/org/$org/loop/$loopId/dashboard')({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  validateSearch: zodValidator(insightsDeliverablesSearchSchema),
  beforeLoad: requirePermission('edit_insights'),
  staticData: {
    topNav: {
      title: i18n.t($ => $.loops.insights)
    }
  }
});